import React from "react";
import ReactECharts from "echarts-for-react";
import { Spin, Empty, Grid } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

interface IssueStatusChartProps {
  loading: boolean;
  issueData: { status: string; count: number }[] | null;
}

const IssueStatusChart: React.FC<IssueStatusChartProps> = ({
  loading,
  issueData,
}) => {
const getChartOptions = () => {
  if (!issueData || issueData.length === 0) return {};

  return {
    animationDuration: 1000,
    tooltip: {
      trigger: "item",
      formatter: "{b} - {c} ({d}%)",
    },
    legend: {
      orient: "vertical",
      right: 10,
      top: 20, // move legend up
      textStyle: {
        fontSize: 14,
      },
      formatter: (name: string) => {
        const item = issueData.find((i) => i.status === name);
        return item ? `${name} - ${item.count}` : name;
      },
    },
    series: [
      {
        name: "Issue Status",
        type: "pie",
        radius: "80%",
        center: ["50%", "60%"], 
        label: {
          show: false,
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 18,
            fontWeight: "bold",
          },
        },
        labelLine: {
          show: false,
        },
        data: issueData.map((item) => ({
          name: item.status,
          value: item.count,
        })),
      },
    ],
    color: ["#2ec7c9", "#fbc02d", "#ff7043", "#9c27b0"],
  };
};

  if (loading) {
    return (
      <div style={{ height: 260, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
      </div>
    );
  }

  if (!issueData || issueData.length === 0) {
    return (
      <div style={{ height: 260, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Empty description="No data found" />
      </div>
    );
  }

  return (
    <ReactECharts
      option={getChartOptions()}
      style={{ height: 260, width: "100%" }}
      notMerge={true}
      lazyUpdate={true}
    />
  );
};

export default IssueStatusChart;
